import { Navigate, Outlet } from 'react-router-dom'

import navigateToNextOnboardingPageAction from '@actions/navigateToNextOnboardingPageAction'
import skipOnboardingLoader from '@app-studio-web/ui/loaders/skipOnboardingLoader'

// Baseline pages - original shorter onboarding flow (control)
import BudgetRangePage from './BudgetRangePage'
import ClutterLevelPage from './ClutterLevelPage'
import ColorPreferencePage from './ColorPreferencePage'
import CompletePage from './CompletePage'
import ConditionalBudgetPage from './ConditionalBudgetPage'
import ConditionalClutterPage from './ConditionalClutterPage'
import HelpMethodPage from './HelpMethodPage'
import HomeSizePage from './HomeSizePage'
import MoodImpactInsightPage from './MoodImpactInsightPage'
import MoodScalePage from './MoodScalePage'
import PersonalityTypePage from './PersonalityTypePage'
import PlantPreferencePage from './PlantPreferencePage'
import PriorityPage from './PriorityPage'
import SpaceVibePage from './SpaceVibePage'
import StyleVibePage from './StyleVibePage'

/**
 * Baseline Routes - Original onboarding flow (control)
 *
 * This is the original/shorter onboarding flow used as the control
 * variant for A/B testing.
 */
const onboardingRoutes = [
  {
    path: '',
    element: <Outlet />,
    loader: skipOnboardingLoader,
    children: [
      {
        element: <Navigate to="space-vibe" replace />,
        index: true,
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <SpaceVibePage />,
        path: 'space-vibe',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <HelpMethodPage />,
        path: 'help-method',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <HomeSizePage />,
        path: 'home-size',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <PersonalityTypePage />,
        path: 'personality-type',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <ClutterLevelPage />,
        path: 'clutter-level',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <ConditionalClutterPage />,
        path: 'conditional-clutter',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <StyleVibePage />,
        path: 'style-vibe',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <ColorPreferencePage />,
        path: 'color-preference',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <PriorityPage />,
        path: 'priority',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <PlantPreferencePage />,
        path: 'plant-preference',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <BudgetRangePage />,
        path: 'budget-range',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <ConditionalBudgetPage />,
        path: 'conditional-budget',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <MoodScalePage />,
        path: 'mood-scale',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <MoodImpactInsightPage />,
        path: 'mood-impact-insight',
      },
      {
        action: navigateToNextOnboardingPageAction,
        element: <CompletePage />,
        path: 'complete',
      },
    ],
  },
]

export default onboardingRoutes
